const ColumnData = [
  { label: "Bank", accessor: "bankName", type: "string" },
  { label: "Product type", accessor: "productType", type: "string" },
  { label: "Sharia", accessor: "sharia", type: "string" },
  { label: "Minimum deposit", accessor: "minDeposit", type: "currency" },
  { label: "Maximum deposit", accessor: "maxDeposit", type: "currency", hiddenOn: "JOINT" },
  { label: "Maximum deposit", accessor: "jointMaxDeposit", type: "currency", shownOn: "JOINT" },
  { label: "Feature notice period", accessor: "featureNoticePeriod", type: "number" },
  { label: "Feature term period (months)*", accessor: "featureTermPeriod", type: "number" },
  { label: "AER rate", accessor: "aerRate", type: "number" },
  { label: "Gross rate", accessor: "grossRate", type: "number" },
];

export default ColumnData;
